module.exports = __webpack_public_path__ + "static/media/Jamar-Resume.7b6df537.pdf";